import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Problems } from './components/Problems';
import { WhatsIncluded } from './components/WhatsIncluded';
import { HowItWorks } from './components/HowItWorks';
import { Benefits } from './components/Benefits';
import { BonusSection } from './components/BonusSection';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalOffer } from './components/FinalOffer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-brand-ink selection:bg-brand-cream-100 selection:text-brand-ink pb-20 sm:pb-0" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <SocialProof data-id="element-3" />
        <Problems data-id="element-4" />
        <WhatsIncluded data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <Benefits data-id="element-7" />
        <BonusSection data-id="element-8" />
        <Testimonials data-id="element-9" />
        <FAQ data-id="element-10" />
        <FinalOffer data-id="element-11" />
      </main>

      <Footer data-id="element-12" />

      {/* Sticky Mobile CTA — subtle, premium */}
      <div className="sm:hidden fixed bottom-0 left-0 right-0 p-3 bg-white/95 backdrop-blur-md border-t border-slate-100 z-40" data-id="element-13">
        <a href="https://impulsodigital.vip/cart/44763616936022:1" className="flex items-center justify-between w-full bg-brand-green-500 active:bg-brand-green-600 text-white px-5 py-3.5 rounded-xl font-bold shadow-btn transition-colors" data-id="element-14">
          <span className="text-sm" data-id="element-15">Quiero el kit por $19.990</span>
          <span className="text-lg" aria-hidden="true" data-id="element-16">
            →
          </span>
        </a>
      </div>
    </div>;
}